export default __webpack_public_path__ + "static/media/camera_loading.414c4788.gif";